<template>
  <div>
    <kn-jumbotron></kn-jumbotron>
    <b-container fluid class="container1">
      <b-row id="mcRow">
        <kn-sideMenu></kn-sideMenu>
        <main role="main" class="ml-sm-auto pt-3 px-4 mx-auto col-md-9" style="max-width: 100%;">
          <h2><span class="Block blue"></span>Δεκαετία {{ decade }}</h2>
          <b-row class="mt-4">
            <!-- Loop through the years of the selected decade and create a box for each -->
            <b-col v-for="year in years" :key="year" cols="3" class="mb-4">
              <div class="year-box">
                <router-link :to="`/${decade}/${year}`" class="no-underline year-link">
                  <h4 class="year-text">{{ year }}</h4>
                </router-link>
              </div>
            </b-col>
          </b-row>
        </main>
      </b-row>
    </b-container>
    <kn-footer></kn-footer>
  </div>
</template>

<script>
import jumbotron from './jumbotron.vue';
import sideMenu from './sideMenu.vue';
import footer from './footer.vue'
export default {
  components: {
    "kn-jumbotron": jumbotron,
    "kn-sideMenu": sideMenu,
    "kn-footer": footer
  },
  props: {
    decade: {
      type: Number, // The decade should now be a number
      required: true,
    }
  },
  computed: {
    years() {
      const startYear = this.decade; // Use the passed decade as a number
      const currentYear = new Date().getFullYear(); // Get the current year -Change this when the first pdf of 2025 is loaded in this component.
      let endYear = startYear + 9; // Default to 10 years in the decade

      // For the 2020s, limit the years up to the current year (2025)
      if (startYear === 2020) {
        endYear = Math.min(currentYear, 2025); // Make sure to not exceed 2025
      }

      // Generate the years for the selected decade
      return Array.from({ length: endYear - startYear + 1 }, (_, i) => startYear + i);
    },
  },
}
</script>

<style scoped>
.year-box {
  border: 2px solid #cccccc;
  /* Grey borders */
  height: 105px;
  width: 105px;
  cursor: pointer;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #5d8bec;
  /* Default background color */
  transition: background-color 0.3s, color 0.3s;
}

.year-box:hover {
  background-color: white;
  /* Blue background on hover */
}

.year-link {
  display: flex;
  justify-content: center;  /* Horizontally center the text */
  align-items: center;  /* Vertically center the text */
  width: 100%;
  height: 100%;
  text-decoration: none; 
}

.year-text {
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  margin: 0;
  color: white;
  /* Black text by default */
}

.year-box:hover .year-text {
  color: #5fabf1;
  /* Change text color to white on hover */
}

span.Block.blue {
  background: #4c81a6;
  display: inline-block;
  width: 5px;
  height: 23px;
  margin-right: 5px;
}

/* Remove the underline from router-link */
.router-link-exact-active,
.router-link-active,
.no-underline {
  text-decoration: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/decadeComponent.vue